import { render, staticRenderFns } from "./PurchasingInstructionReport.vue?vue&type=template&id=a6265480&"
import script from "./PurchasingInstructionReport.vue?vue&type=script&lang=js&"
export * from "./PurchasingInstructionReport.vue?vue&type=script&lang=js&"
import style0 from "./PurchasingInstructionReport.vue?vue&type=style&index=0&id=a6265480&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports